export const angleUnits = [
  { name: "Meter", symbol: "m", to_base_factor: 1 },
  { name: "Kilometer", symbol: "km", to_base_factor: 1000 },
  { name: "Million Kilometer", symbol: "million km", to_base_factor: 1_000_000 },
  { name: "Astronomical Unit", symbol: "AU", to_base_factor: 149_597_870.7 },
  { name: "Light Year", symbol: "light year", to_base_factor: 9.461e+15 },
  { name: "Parsec", symbol: "parsec", to_base_factor: 3.086e+16 },
];
